import React from "react";

function OrionHubPage() {
  return (
    <iframe
      src="/orionhub-landing/landing.html"
      title="OrionHub 2026"
      style={{
        width: "100%",
        height: "100vh",
        border: "0",
        display: "block",
      }}
    />
  );
}

export default OrionHubPage;
